import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasCustomer } from 'app/shared/model/ainnotateservice/aidas-customer.model';
import { getEntities as getAidasCustomers } from 'app/entities/ainnotateservice/aidas-customer/aidas-customer.reducer';
import { getEntity, updateEntity, createEntity, reset } from './aidas-project.reducer';
import { IAidasProject } from 'app/shared/model/ainnotateservice/aidas-project.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasProjectUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasCustomers = useAppSelector(state => state.aidasCustomer.entities);
  const aidasProjectEntity = useAppSelector(state => state.aidasProject.entity);
  const loading = useAppSelector(state => state.aidasProject.loading);
  const updating = useAppSelector(state => state.aidasProject.updating);
  const updateSuccess = useAppSelector(state => state.aidasProject.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-project' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasCustomers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...aidasProjectEntity,
      ...values,
      aidasCustomer: aidasCustomers.find(it => it.id.toString() === values.aidasCustomerId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...aidasProjectEntity,
          aidasCustomerId: aidasProjectEntity?.aidasCustomer?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ainnotategwApp.ainnotateserviceAidasProject.home.createOrEditLabel" data-cy="AidasProjectCreateUpdateHeading">
            Create or edit a AidasProject
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="aidas-project-id" label="ID" validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label="Name"
                id="aidas-project-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 3, message: 'This field is required to be at least 3 characters.' },
                  maxLength: { value: 500, message: 'This field cannot be longer than 500 characters.' },
                }}
              />
              <ValidatedField label="Description" id="aidas-project-description" name="description" data-cy="description" type="text" />
              <ValidatedField label="Project Type" id="aidas-project-projectType" name="projectType" data-cy="projectType" type="text" />
              <ValidatedField
                id="aidas-project-aidasCustomer"
                name="aidasCustomerId"
                data-cy="aidasCustomer"
                label="Aidas Customer"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasCustomers
                  ? aidasCustomers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-project" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasProjectUpdate;
